import { all, fork } from 'redux-saga/effects';

import loginSaga from './login/saga';

function* authenticationSaga() {
    yield all([
        fork(loginSaga),
    ]);
}

export default authenticationSaga;